<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()


</script>






<template>
  <!-- Hero Section -->
  <section class="hero">
    <img src="../assets/img/venuebg.png" alt="Hero background" />
    <h1>
      <span class="bold-text">{{ t('venue.heroTitle') }}</span>
    </h1>
   
  </section>

  <section class="announcement">

    <h4 v-html="t('venue.comingSoon')"></h4>
 <h5 v-html="t('venue.description')"></h5>
    <!-- <section class="newsletter">
      <h2>{{ t('venue.newsletterTitle') }}</h2>
      <form class="newsletter-form">
        <input
          type="email"
          :placeholder="t('venue.newsletterPlaceholder')"
          class="newsletter-input"
        />
        <button type="submit" class="newsletter-btn">
          {{ t('venue.newsletterButton') }}
        </button>
      </form>
    </section> -->
  </section>
</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=League+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Doto:wght@100..900&family=Mea+Culpa&display=swap');
</style>
<style scoped>
body{
  font-family: 'Montserrat', sans-serif;
  font-family: 'League Gothic', sans-serif;
  font-family: 'Cormorant Garamond'sans-serif;
 }
/* HERO */

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1;

}
.hero {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 5rem;
}
.hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(75%);
   backdrop-filter: blur(5px);
}

.hero-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(100%);
  z-index: 0;
  
}


.hero h1 {
  position: absolute;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.5rem;
  font-size: 4rem;
  text-align: center;
z-index: 10;
}


.bold-text {
  font-family: 'League Gothic', sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 4rem;
  color: white;
}


h4{
    font-family:'Montserrat', sans-serif;
    font-size: 6rem;
    font-weight: 300;
    text-align: center;
    margin: 2rem;
}
h5{
    font-family:'Montserrat', sans-serif;
    font-size: 1.6rem;
    font-weight: 300;
    text-align: center;
    margin: 6rem;
     text-decoration: underline;
}

.info{
margin: auto;

}

.info h5{
  font-family:'Montserrat', sans-serif;
   font-size: 2rem;
    font-weight: 300;
    text-align: center;
    text-decoration: underline 2px;
}
/*Infoletter*/
.newsletter {
  text-align: center;
  margin: 4rem auto;
  font-family: "Cormorant Garamond", serif;
}

.newsletter h2 {
  font-size: 1.5rem;
  text-decoration: underline;
  margin-bottom: 1.5rem;
}

.newsletter-form {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #333;
  width: 420px;
  margin: 0 auto;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
}

.newsletter-input {
  flex: 1;
  border: none;
  padding: 0.8rem 1rem;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  outline: none;
}

.newsletter-btn {
  background: transparent;
  border: none;
  padding: 0.8rem 1.5rem;
  font-family: "Cormorant Garamond", serif;
  font-size: 1.1rem;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease;
  font-style: italic;
}

.newsletter-btn:hover {
  color: #555;
}

/* ---------- HERO ---------- */
@media (max-width: 1024px) {

  .hero h1 {
    font-size: 3.5rem;
  }

  .bold-text {
    font-size: 4.5rem;
  }
  .bold-text {
    font-size: 4rem;
  }

  .italic-text {
    font-size: 3rem;
  }
}


  h4 {
    font-size: 4rem;
    margin: 1.5rem;
  }


  .newsletter-form {
    width: 80%;
  }

@media (max-width: 768px) {
  .hero h1 {
    flex-direction: column;
    font-size: 2.5rem;
    gap: 0.2rem;
  }

  .hero{
    height: 80vh;
  }
  .bold-text {
    font-size: 3.5rem;
  }

  h4 {
    font-size: 3rem;
  }

  .newsletter h2 {
    font-size: 1.5rem;
  }

  .newsletter-form {
    flex-direction: column;
    width: 90%;
    box-shadow: none;
    border: none;
  }

  .newsletter-input {
    width: 100%;
    border: 1px solid #333;
    margin-bottom: 1rem;
  }

  .newsletter-btn {
    border: 1px solid #333;
    width: 100%;
    padding: 0.8rem;
  }
}

@media (max-width: 480px) {
  .hero h1 {
    font-size: 2rem;
  }

  .bold-text {
    font-size: 2.8rem;
  }
  h5{
    font-family:'Montserrat', sans-serif;
    font-size: 1rem;
    font-weight: 300;
    text-align: center;
    margin: 3rem;
    text-decoration: underline;
}

  h4 {
    font-size: 2rem;
    margin: 1rem;
  }

  .newsletter h2 {
    font-size: 1.2rem;
  }

  .newsletter-input {
    font-size: 0.9rem;
  }

  .newsletter-btn {
    font-size: 1rem;
  }
}
</style>